import React from 'react';
import Header from './Header';
import ProductSearchComponent from './product/ProductSearchComponent';
import { withTranslation, WithTranslation } from "react-i18next";
import ApplicationState from "src/model/ApplicationState";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { setWeblabStart } from "src/actions/WeblabAction";
import ProgramComparisonComponent from './program/ProgramComparisonComponent';
import { setProductDataQueryStart } from "src/actions/ProductSearchAction";
import {
    setCurrentCountryCodeAction,
} from "src/actions/CurrentCountryCodeQueryAction";
import initialMetricsPublisher, { makeMetricsDriver } from 'src/metrics';
import MetricsUtil from 'src/utils/MetricsUtil';
import { getCountryListConfig, isLoginMode } from "src/config/Config";
import LoginReminderComponent from "src/components/common/LoginReminderComponent";
import { setUserPreferenceQueryStart } from "src/actions/UserPreferenceAction";

interface DispatchProps {
    readonly dispatchWeblabTreatments: () => void;
    readonly dispatchGetProduct: (countryCode: string, searchKey: string) => void,
    readonly dispatchGetUserPreference: () => void,
    readonly dispatchSetCurrentCountryCode: (countryCode: string) => void;
}

interface OwnProps {
}

interface StateProps {
}

interface State {
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => (
    bindActionCreators({
        dispatchWeblabTreatments: setWeblabStart,
        dispatchGetProduct: setProductDataQueryStart,
        dispatchGetUserPreference: setUserPreferenceQueryStart,
        dispatchSetCurrentCountryCode: setCurrentCountryCodeAction,
    }, dispatch)
);

const mapStateToProps = (state: ApplicationState): StateProps => ({
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type Props = StateProps & DispatchProps & OwnProps & WithTranslation;


export class AppMainLayout extends React.Component<Props, State> {

    private readonly countryCode: string = new URLSearchParams(window.location.search).get("countryCode") || "";
    private readonly msku: string = new URLSearchParams(window.location.search).get("merchantSku") || "";

    readonly metricsUtil = new MetricsUtil(makeMetricsDriver(), initialMetricsPublisher, 'RCv2.0');

    componentDidMount() {
        if (isLoginMode()) {
            this.props.dispatchWeblabTreatments();
            this.props.dispatchGetUserPreference();
        } else {
            this.props.dispatchSetCurrentCountryCode(getCountryListConfig()[0]);
        }
        if (!!this.countryCode && !!this.msku) {
            this.props.dispatchGetProduct(this.countryCode, this.msku);
            this.props.dispatchSetCurrentCountryCode(this.countryCode);
            this.publishRequestWithParamsCounter();
        }
    }

    publishRequestWithParamsCounter() {
        if (this.metricsUtil) {
            this.metricsUtil.publishCounter("requestWithParams", isLoginMode() ? "login": "public")
        }
    }

    render() {
        return (
            <>
                <Header metricsUtil={this.metricsUtil} />
                <ProductSearchComponent metricsUtil={this.metricsUtil} />
                <ProgramComparisonComponent metricsUtil={this.metricsUtil} />
                {!isLoginMode() && <LoginReminderComponent />}
            </>
        );
    }
}

export default withTranslation()(connector(AppMainLayout));
